import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-839451aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainCardPreloadComponent = _resolveComponent("MainCardPreloadComponent")!
  const _component_MainCardComponent = _resolveComponent("MainCardComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (row) => {
      return _withDirectives(_createVNode(_component_MainCardPreloadComponent, null, null, 512), [
        [_vShow, _ctx.getCardsPreloaders.popular]
      ])
    }), 64)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPopularMods, (row) => {
      return _withDirectives((_openBlock(), _createBlock(_component_MainCardComponent, { data: row }, {
        "tr-badge": _withCtx(() => [
          _createTextVNode(" Топ просмотров ")
        ]),
        _: 2
      }, 1032, ["data"])), [
        [_vShow, !_ctx.getCardsPreloaders.popular]
      ])
    }), 256))
  ]))
}